const TOKEN_PREFIX = 'fbw_live_';

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const chunks = token.split('.');
  if (chunks.length !== 3) return null;

  try {
    const payload = atob(chunks[1].replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(payload) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export class TokenManager {
  private readonly token: string;

  constructor(rawToken: string) {
    this.token = rawToken.trim();
  }

  getToken(): string {
    return this.token;
  }

  validateFormat(): boolean {
    return this.token.startsWith(TOKEN_PREFIX) && this.token.length >= 20;
  }

  isExpired(nowUnixSeconds: number = Math.floor(Date.now() / 1000)): boolean {
    const payload = decodeJwtPayload(this.token);
    if (!payload || typeof payload.exp !== 'number') return false;
    return nowUnixSeconds >= payload.exp;
  }
}

